import { createDefault } from "../../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "期間開始前", enum: "APPROVED" },
  { value: 2, text: "期間中", enum: "WITHINTERM" },
  { value: 3, text: "期間終了", enum: "ENDTERM" },
  { value: 4, text: "検品済み", enum: "INSPECTED" },
  { value: 5, text: "完了", enum: "COMPLETED" },
]);
